import { useEffect, useState } from "react";
import styled from "styled-components";

interface LiveSoundButtonProps {
  visible: boolean;
  onUnmute: () => void;
}

export default function LiveSoundButton({ visible, onUnmute }: LiveSoundButtonProps) {
  const [prominent, setProminent] = useState(true);

  useEffect(() => {
    if (!visible || !prominent) return;
    const timer = window.setTimeout(() => setProminent(false), 2000);
    return () => window.clearTimeout(timer);
  }, [visible, prominent]);

  if (!visible) return null;

  return (
    <SoundButton type="button" aria-label="소리 켜기" $prominent={prominent} onClick={onUnmute}>
      <img src={prominent ? require("../../Image/ic_sound.png") : require("../../Image/ic_sound2.png")}
        alt="" draggable={false} />
    </SoundButton>
  );
}

const SoundButton = styled.button<{ $prominent: boolean }>`
  position: absolute;
  z-index: 45;
  top: ${({ $prominent }) => $prominent ? "50%" : "10%"};
  left: ${({ $prominent }) => $prominent ? "50%" : "auto"};
  right: ${({ $prominent }) => $prominent ? "auto" : "30px"};
  transform: ${({ $prominent }) => $prominent ? "translate(-50%, -50%)" : "none"};
  width: ${({ $prominent }) => $prominent ? "200px" : "80px"};
  height: ${({ $prominent }) => $prominent ? "200px" : "80px"};
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  img { display: block; width: 100%; height: 100%; }
  &:active { opacity: 0.8; }
  &:focus-visible { outline: 2px solid white; outline-offset: 4px; }
`;
